import styles from './Categories.module.scss';
import { useTheme } from '../../hooks/theme';

interface PartnerSelectionProps {
  partners: Partner[];
  selected: Partner;
  select: (partner: Partner) => void;
}

const PartnerSelection = ({
  partners,
  select,
  selected,
}: PartnerSelectionProps) => {
  const { theme } = useTheme();

  return (
    <div className={styles.usersCategories}>
      <ul>
        {partners.map(partner => (
          <li
            key={partner.partner_id}
            onClick={() => select(partner)}
            className={`${styles[theme]}${
              selected === partner ? ` ${styles.active}` : ''
            }`}
          >
            {partner.partner_name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PartnerSelection;
